module.exports = __webpack_public_path__ + "assets/img/slogan-ec0fc2dc.png";